export enum SeasonEnum {
  Summer = 0,
  Winter = 1,
  AllSeason = 2,
  All = 3,
}

export enum TornEnum {
  NoTorn = 0,
  Torn = 1,
  AllTypes = 2,
}

export enum SpecName {
  SpecSeason = 'Сезонность',
}

export enum StudEnum {
  NotStudded = 0,
  Studded = 1,
}

export enum ProductSpecCode {
  SellerCode = 'sellercode',
  Width = 'tyre_width',
  Height = 'tyre_height',
  Diameter = 'tyre_radius',
  Season = 'tyre_season',
  Spikes = 'tyre_torn',
  Loads = 'tyre_powerload',
  SpeedIndex = 'tyre_speed',
  Homologation = 'tyre_homologation',
  ManufacturerCode = 'mnfcode',
  RunFlat = 'tyre_runflat',
  LoadIndex = 'tyre_loads',
  TypeAuto = 'tyre_cartype',

  TruckTyresWidth = 'trucktyres_width',
  TruckTyresHeight = 'trucktyres_height',
  TruckTyresDiam = 'trucktyres_diam',
  TruckTyresLoad = 'trucktyres_load',
  TruckTyresSpeed = 'trucktyres_speed',
  TruckTyresLayer = 'trucktyres_layer',
  TruckTyresAxle = 'trucktyres_axle',
  TruckTyresType = 'trucktyres_type',

  DiskWidth = 'disk_width',
  DiskWidthMin = 'disk_width_min',
  DiskWidthMax = 'disk_width_max',
  DiskRadius = 'disk_radius',
  DiskPcde = 'disk_pcde',
  DiskPcdd = 'disk_pcdd',
  DiskUnitedPcd = 'unitedpcd',
  DiskMount = 'disk_mount',
  DiskEt = 'disk_et',
  DiskEtMin = 'disk_et_min',
  DiskEtMax = 'disk_et_max',
  DiskDia = 'disk_dia',
  DiskDiaMin = 'disk_dia_min',
  DiskDiaMax = 'disk_dia_max',

  DiskSale = 'disk_sale',
  DiskColor = 'disk_color',
  DiskProcessWay = 'disk_processWay',
  DiskType = 'disk_type',

  AkbWidth = 'battery_width',
  AkbHeight = 'battery_height',
  AkbLength = 'battery_length',
  AkbSize = 'battery_size',
  AkbCapacity = 'battery_capacity',
  AkbPolarity = 'battery_polarity',
  AkbCranking = 'battery_cranking',
  AkbVoltage = 'battery_voltage',

  OilViscosity = 'oil_viscosity',
  OilVolume = 'oil_volume',
  OilType = 'oil_type',
  OilApi = 'oil_api',
  OilAcea = 'oil_acea',
  OilLimit = 'oil_limit',

  Size = 'size',
  Brand = 'brand',
  Model = 'model',
  Country = 'country',
  BrandClass = 'brand-class',
  ExtendedWarranty = 'extended-warranty',
  BackProduct = 'back-product',
  StandardFactory = 'standard-factory',
}

export enum ExtraExtraAttributes {
  Size = 'Типоразмер',
  Brand = 'Бренд',
  Model = 'Модель',
  Country = 'Страна бренда',
  BrandClass = 'Класс бренда',
  ExtendedWarranty = 'Гарантия',
}

export enum ProductSpecTyres {
  Width = 'Ширина шины',
  Height = 'Высота',
  Diameter = 'Диаметр',
  Season = 'Сезонность',
  Spikes = 'Шипы',
  LoadIndex = 'Индекс нагрузки',
  SpeedIndex = 'Индекс скорости',
  Homologation = 'Омологация',
  ManufacturerCode = 'Артикул',
  VendorCode = 'Код продавца',
  RunFlat = 'Run Flat',
  Loads = 'Усиленность шины',
  TypeAuto = 'Категория автомобиля',
  Size = 'Типоразмер',
}

export enum ProductShortSpecTyres {
  Width = 'Ширина',
  Height = 'Высота',
  Diameter = 'Диаметр',
  Season = 'Сезонность',
  Spikes = 'Шипы',
  LoadIndex = 'Индекс нагрузки',
  SpeedIndex = 'Индекс скорости',
  Homologation = 'Омологация',
  ManufacturerCode = 'Артикул',
  VendorCode = 'Код продавца',
  RunFlat = 'Run Flat',
  Loads = 'Усиленность шины',
  Axle = 'Ось',
  Type = 'Тип',
  Layer = 'Слойность',
}

export enum ProductSpecDisks {
  Width = 'Ширина',
  Diameter = 'Диаметр',
  PCD = 'Крепление (PCD)',
  ET = 'Вылет (ET)',
  DIA = 'Центральное отверстие (DIA)',
  Color = 'Цвет',
  Type = 'Тип',
  ManufacturerCode = 'Код производителя',
  VendorCode = 'Код продавца',
}
export enum ProductShortSpecDisks {
  Width = 'Ширина',
  Diameter = 'Диаметр',
  PCD = 'PCD',
  ET = 'ET',
  DIA = 'DIA',
  Color = 'Цвет',
  Type = 'Тип',
  ManufacturerCode = 'Код производителя',
  VendorCode = 'Код продавца',
}

export enum ProductSpecAkb {
  Width = 'Ширина',
  Height = 'Высота',
  Length = 'Длина',
  Capacity = 'Емкость',
  Polarity = 'Полярность',
  Cranking = 'Пусковой ток',
  TerminalLocation = 'Положение клемм',
  TerminalType = 'Тип клемм',
  ManufacturerCode = 'Код производителя',
  VendorCode = 'Код продавца',
  Continent = 'Гео тип',
}

export enum ProductSpecOils {
  Viscosity = 'Вязкость',
  Volume = 'Упаковка',
  Api = 'Спецификация API',
  Acea = 'Спецификация ACEA',
  Type = 'Тип масла',
  OilLimit = 'Допуск',
  VendorCode = 'Код продавца',
}

export enum IconName {
  Discount = 'discount.svg',
  Express = 'express.svg',
  Favorites = 'favorites.svg',
  FreeStorage = 'freeStorage.svg',
  Hit = 'hit.svg',
  New = 'new.svg',
  Present = 'present.svg',
  Sber = 'sber.svg',
  Warranty = 'warranty.svg',
}

export enum Part {
  'Tyres' = 11,
  'Disks' = 21,
  'TruckTires' = 31,
  'MotoTires' = 41,
  'Batteries' = 51,
  'RelatedProducts' = 61,
  'Oils' = 71,
  'Secrets' = 81,
  'Collections' = 501,
}

export enum PartProduct {
  'Tyres' = 1,
  'Disks' = 2,
  'TruckTires' = 3,
  'MotoTires' = 4,
  'Batteries' = 5,
  'RelatedProducts' = 6,
  'Oils' = 7,
  'Secrets' = 8,
  'Collections' = 501,
}

export enum PartBrand {
  'Tyres' = 10,
  'Disks' = 20,
  'TruckTires' = 30,
  'MotoTires' = 40,
  'Batteries' = 50,
  'RelatedProducts' = 60,
  'Oils' = 70,
  'Secrets' = 80,
}

export enum TabTitle {
  Availability = 'Наличие',
  ProductSpecs = 'Характеристики',
  ProductReview = 'Обзор',
  Reviews = 'Отзывы',
  FitsTheCar = 'Подходит к авто',
  HowToBuy = 'Как купить',
  Analogues = 'Аналоги',
}

export enum Tab {
  Availability,
  ProductSpecs,
  ProductReview,
  Reviews,
  Analogues,
  FitsTheCar,
  HowToBuy,
}

export const connectionBetweenNameAndNumber: { [key: string]: Tab } = {
  [TabTitle.Availability]: Tab.Analogues,
  [TabTitle.ProductSpecs]: Tab.ProductSpecs,
  [TabTitle.ProductReview]: Tab.ProductReview,
  [TabTitle.Reviews]: Tab.Reviews,
  [TabTitle.FitsTheCar]: Tab.FitsTheCar,
  [TabTitle.HowToBuy]: Tab.HowToBuy,
  [TabTitle.Analogues]: Tab.Analogues,
};

export enum ButtonId {
  Reviews = 'button__productTabFeedback',
}

export enum ElementIdTab {
  TabAvailabilityFast = 'block-get-product-in-shop',
  TabAvailabilityNoFast = 'block-get-product-tomorrow',
  TabAvailabilityRecordOrder = 'block-get-product-order',
  TabAvailability = 'productTabAvailability',
  TabProductSpecs = 'productTabProductSpecs',
  TabProductReview = 'productTabProductReview',
  TabVideo = 'productTabVideo',
  TabReviews = 'sp-product-reviews-widget',
  TabHowToBuy = 'productTabHowToBuy',
  TabAnalogues = 'productTabAnalogues',
  TabFitsTheCar = 'productTabFitsTheCar',
  TabProduct = 'productTabs',
  TabProductMobile = 'productTabMobile',
  BlockAvailability = 'block-availability',
  BlockAvailabilityDelivery = 'block-availability-delivery',
}

export interface Brand {
  name: string;
  image: string;
  href: string;
  code?: string;
}

export interface ProductSpecs {
  title: string;
  value: string | number;
  code: ProductSpecCode;
  transcript?: string;
  href?: string;
  loading?: boolean;
  meta?: any;
}

export interface TabType {
  title: TabTitle;
  quantity?: number;
  tabElementId?: ElementIdTab;
  buttonId?: ButtonId;
}

export interface SEOLink {
  title: string;
  href: string;
}

export type seoType = {
  h1: string;
  title: string;
  description: string;
  keywords: string;
  text: string;
  links: SEOLink[];
  h2?: string;
};

type modelType = {
  name: string;
  href: string;
  code?: string;
};
type categoryItem = {
  name: string;
  url: string;
};

export type mediaType = {
  type: 'image' | 'video';
  src: string;
};

export interface Product {
  images: string[];
  videos: string[];
  media: mediaType[];
  id: number;
  rn: number;
  allQuantity: number;
  part: Part | PartProduct;
  price: number;
  originalPrice: number;
  categories: categoryItem[];
  brand: Brand;
  model: modelType;
  productName: string;
  productSpecs: ProductSpecs[];
  actualQuantity?: number;
  seo: seoType;
}

export type ItemActionType = {
  name: string;
  href: string;
};

export type BadgeType = {
  iconName?: IconName;
  slug?: IconName;
  items: ItemActionType[];
  href: string;
  text: string;
};

type BrandType = {
  id: number;
  name: string;
  url: string;
  thumb: string;
  sort: number;
  globalSort: any;
};

type ModelType = {
  id: number;
  name: string;
  url: string;
  sort: number;
};

export interface AnalogsProductType {
  productId: number;
  part: number;
  rn: number;
  brand: BrandType;
  model: ModelType;
  href: string;
  season: SeasonEnum;
  name: string;
  badges: BadgeType[];
  quantity: number;
  price: number;
}

export interface NewAnalogsProductType {
  id: number;
  rn: number;
  code: string;
  radius: null;
  width: number;
  height: number;
  speed: string;
  loads: string;
  torn: string;
  tornType: null;
  runflat: null;
  carType: null;
  powerload: null;
  purpose: null;
  homologation: null;
  mnfCode: string;
  xmlId: null;
  sale: number;
  price: number;
  reserv: string;
  quantity: string;
  season: number;
  compId: null;
  import: string;
  part: string;
  catalogId: number;
  description: string;
  badges: BadgeType[];
  brand: any;
  model: any;
}

export interface AnaloguesProductSchema {
  analogsProduct: AnalogsProductType[];
  initData: boolean;
  isLoadingData: boolean;
}

export interface ReviewProductType {
  reviewProduct: string;
}

export interface AnaloguesProductType {
  analogsProduct: null;
}

export interface VideosProductType {
  videos: string;
}

export interface ProductSchema {
  product?: Product;
  activeTab?: TabTitle;
  tabs: TabType[];
  hideShopTwoHours: boolean;
  isLoadedData: boolean;
  reviewProduct: string;
}

export enum ProductSpecifications {
  ManufacturerCode = 'mnfcode',
  SellerCode = 'sellercode',
  ReturnProduct = 'return-product',
  TyresWidth = 'tyres_width',
  TyresProfile = 'tyres_profile',
  TyresDiameter = 'tyres_diameter',
  TyresBSHM = 'tyres_bshm',
  TyresMinPrice = 'tyres_minprice',
  TyresMaxPrice = 'tyres_maxprice',
  TyresIsCommercial = 'tyres_is_commercial',
  TyresSeason = 'tyres_season',
  TyresThorn = 'tyres_thorn',
  TyresRunFlat = 'tyres_runflat',
  TyresHide4 = 'tyres_hide4',
  TyresDeveloper = 'tyres_developer',
  TyresSaleFlag = 'tyres_saleflag',
  TyresLoadIndex = 'tyre_loads',
  TyresTypeAuto = 'tyres_cartype',
  TyresLoads = 'tyres_powerload',
  TyresSpeedIndex = 'tyres_speed',
  TyresHomologation = 'tyres_homologation',

  DiscsDiameter = 'discs_diameter',
  DiscsPcd = 'discs_pcd',
  MinDiscsDia = 'min_discs_dia',
  MaxDiscsDia = 'max_discs_dia',
  DiscsDia = 'discs_dia',
  MinDiscsEt = 'min_discs_et',
  MaxDiscsEt = 'max_discs_et',
  DiscsEt = 'discs_et',
  MinDiscsWidth = 'min_discs_width',
  MaxDiscsWidth = 'max_discs_width',
  DiscsWidth = 'discs_width',
  DiscsType = 'discs_type',
  DiscsMinPrice = 'discs_minprice',
  DiscsMaxPrice = 'discs_maxprice',
  DiscsHide4 = 'discs_hide4',
  DiscsDeveloper = 'discs_developer',
  DiscsSaleFlag = 'discs_saleflag',
  DiscsSale = 'discs_sale',
  DiscsColor = 'discs_color',
  DiscsProcessWay = 'discs_processWay',
  DiscsReplica = 'disks_replika',

  AkbDimensions = 'akb_dimensions',
  AkbPolarity = 'akb_polarity',
  AkbCapacity = 'akb_capacity',
  AkbCranking = 'akb_cranking',
  AkbMinPrice = 'akb_minprice',
  AkbMaxPrice = 'akb_maxprice',
  AkbDeveloper = 'akb_developer',

  AkbWidth = 'akb_width',
  AkbHeight = 'akb_height',
  AkbLength = 'akb_length',
  AkbSize = 'akb_size',

  OilViscosity = 'oil_viscosity',
  OilVolume = 'oil_volume',
  OilType = 'oil_type',
  OilApi = 'oil_api',
  OilAcea = 'oil_acea',
  OilMinPrice = 'oil_minprice',
  OilMaxPrice = 'oil_maxprice',
  OilDeveloper = 'oil_developer',

  TruckTyresWidth = 'trucktyres_width',
  TruckTyresProfile = 'trucktyres_profile',
  TruckTyresDiameter = 'trucktyres_diameter',
  TruckTyresAxle = 'trucktyres_axle',
  TruckTyresUseType = 'trucktyres_usetype',
  TruckTyresMinPrice = 'trucktyres_minprice',
  TruckTyresMaxPrice = 'trucktyres_maxprice',
  TruckTyresHide4 = 'trucktyres_hide4',
  TruckTyresDeveloper = 'trucktyres_developer',
  TruckTyresLoad = 'trucktyres_load',
  TruckTyresSpeed = 'trucktyres_speed',
  TruckTyresLayer = 'trucktyres_layer',
  TruckTyresType = 'trucktyres_type',
}
